import MessageFormValidate from "components/shared-components/MessageFormValidate";
import {
  FIELD_EXTRA,
  ISSUE_INVOICE_COMMON_FIELD,
} from "constants/IssueInvoiceConstant";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import "flatpickr/dist/themes/material_blue.css";
import moment from "moment";
import React from "react";
import Autocomplete from "react-autocomplete";
import Flatpickr from "react-flatpickr";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Col, FormGroup, Label, Row, UncontrolledTooltip } from "reactstrap";
import { generateRadioField, generateToggleField } from "./form_helper_old";
import { formatTaxCode } from "./utils";

export const formValidate = (errors, touched, field) => {
  if (field in errors) {
    // return "is-invalid";
    return "";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (field in touched) {
      // return "is-invalid";
      return "";
    } else {
      return "";
    }
  }
};

export const formConvertErrorMessage = (message = "", t, expandMess = "") => {
  // If [t] not a Function
  if (typeof t !== "function") {
    return message;
  }

  let result = message;
  const msgLowerCase = message.toLowerCase();

  if (msgLowerCase.includes("already been taken")) {
    result = t("common:validate.msg_duplicate");
  } else if (msgLowerCase.includes("please correct your data")) {
    result = t("common:validate.msg_correct_data");
  } else if (msgLowerCase.includes("effective time must be greater than")) {
    result = t("common:validate.msg_effective_greater");
  }

  return `${expandMess} ${result} `;
};

export const formValidateObject = (errors, touched, fieldObject, field) => {
  //   console.log("errors", errors);
  //   console.log("touched", touched);
  //   console.log("field", field);
  if (errors[fieldObject] && errors[fieldObject][field]) {
    return "is-invalid";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (fieldObject in touched) {
      if (touched[fieldObject] && touched[fieldObject][field]) {
        return "is-valid";
      }
      return "";
    } else {
      return "";
    }
  }
};

export const formValidateFieldArray = (
  errors,
  touched,
  fieldArray,
  index,
  fieldChild
) => {
  if (
    errors[fieldArray] &&
    errors[fieldArray][index] &&
    errors[fieldArray][index][fieldChild]
  ) {
    return "is-invalid";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (fieldArray in touched) {
      if (
        touched[fieldArray][index] &&
        touched[fieldArray][index][fieldChild]
      ) {
        // return "is-valid";
        return "";
      }
      return "";
    } else {
      return "";
    }
  }
};

// Reack hook form useFieldArray
export const generateInputFieldArray = ({
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  register,
  disabled,
  setInputValueChange = null,
  control,
  isThousandSeparator = false,
  allowNegative = false,
  optionGroup = {},
  onChangeHandle = null,
  extraComponent = {},
  watch,
  decimalScale = 2,
  isTaxCode = false,
}) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  let autoCompleteList =
    optionGroup && optionGroup[fieldChild] ? optionGroup[fieldChild] : [];
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label> */}
      {isTaxCode ? (
        <React.Fragment>
          {/* <div className="d-flex align-items-center gap-1"> */}
          <Controller
            control={control}
            name={`${fieldArray}.${index}.${fieldChild}`}
            render={({ field: { onChange, name, value } }) => (
              <NumberFormat
                format="##########-###"
                autoComplete="off"
                // style={{ maxWidth: "239px", minWidth: "99px" }}
                allowEmptyFormatting={false}
                // placeholder={disabled ? "" : placeholder}
                mask="_"
                allowNegative={allowNegative}
                className={`form-control ${formValidateFieldArray(
                  errors,
                  touched,
                  fieldArray,
                  index,
                  fieldChild
                )}`}
                disabled={disabled}
                value={value}
                onValueChange={v => {
                  let finalValue = formatTaxCode(v.value);
                  onChange(finalValue);
                  onChangeHandle && onChangeHandle(finalValue, fieldChild);
                }}
                id={uniqueId}
              />
            )}
          />
          {/* </div> */}
        </React.Fragment>
      ) : inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          id={uniqueId}
          autoComplete="off"
          type={inputType}
          className={`form-control ${formValidateFieldArray(
            errors,
            touched,
            fieldArray,
            index,
            fieldChild
          )}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldArray}.${index}.${fieldChild}`, {
            // onBlur: e => onBlurHandle(e, fieldArray, index, fieldChild),
          })}
        />
      ) : isThousandSeparator ? (
        <Controller
          control={control}
          name={`${fieldArray}.${index}.${fieldChild}`}
          render={({ field: { onChange, name, value } }) => (
            <NumberFormat
              autoComplete="off"
              thousandSeparator={true}
              decimalScale={decimalScale}
              disabled={disabled}
              isAllowed={value => {
                // if (
                //   fieldChild === "sluong" &&
                //   value.formattedValue.indexOf(".") !== -1
                // ) {
                //   return false;
                // }
                return true;
              }}
              id={uniqueId}
              allowNegative={allowNegative}
              className={`form-control text-right ${formValidateFieldArray(
                errors,
                touched,
                fieldArray,
                index,
                fieldChild
              )}`}
              value={value}
              onValueChange={v => {
                onChange(Number(v.value));
                setInputValueChange &&
                  setInputValueChange({ fieldArray, index, fieldChild });
              }}
            />
          )}
        />
      ) : fieldChild === "thhdvu" && !disabled ? (
        <Controller
          control={control}
          name={`${fieldArray}.${index}.${fieldChild}`}
          render={({ field: { onChange, name, value } }) => (
            <div
              id={uniqueId}
              className={`d-flex justify-content-between autocomplete-input form-control ${formValidateFieldArray(
                errors,
                touched,
                fieldArray,
                index,
                fieldChild
              )}`}
            >
              <Autocomplete
                getItemValue={item => item.code}
                items={autoCompleteList}
                shouldItemRender={(item, value) => {
                  if (value && typeof value === "string") {
                    return (
                      item?.label.toLowerCase().indexOf(value?.toLowerCase()) >
                      -1
                    );
                  }
                  return true;
                }}
                renderItem={(item, isHighlighted) => (
                  <div
                    key={item.label}
                    style={{
                      fontSize: "15px",
                      padding: "4px 10px",
                      background: isHighlighted ? "lightgray" : "white",
                    }}
                  >
                    {item.label}
                  </div>
                )}
                value={value}
                onChange={e => {
                  onChange(e.target.value);
                }}
                onSelect={data => {
                  const product = autoCompleteList.find(
                    item => item.code === data
                  );
                  onChange(product.name);
                  onChangeHandle &&
                    onChangeHandle(fieldArray, index, fieldChild, product);
                }}
              />
              {!disabled &&
                extraComponent &&
                extraComponent[EXTRA_BUTTON.ADD_PRODUCT]}
            </div>
          )}
        />
      ) : (
        <input
          disabled={disabled}
          id={uniqueId}
          autoComplete="off"
          type={inputType}
          className={`form-control ${formValidateFieldArray(
            errors,
            touched,
            fieldArray,
            index,
            fieldChild
          )}`}
          //   placeholder={disabled ? "" : placeholder}
          {...register(`${fieldArray}.${index}.${fieldChild}`, {
            // onBlur: e => {
            //   onBlurHandle && onBlurHandle(e, fieldArray, index, fieldChild);
            // },
          })}
        />
      )}
      {/* {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && ( */}
      <UncontrolledTooltip
        // style={{
        //   color: "red",
        //   background: "white",
        //   border: "1px solid red",
        // }}
        placement="right"
        target={uniqueId}
      >
        {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild]
          ? errors[fieldArray][index][fieldChild].message
          : watch(fieldArray)[index][fieldChild]}
      </UncontrolledTooltip>
      {/* )} */}
    </React.Fragment>
  );
};

export const generateSelectFieldArray = ({
  watch,
  label,
  isRequire,
  errors,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  disabled,
  control,
  options,
  onChangeHandle = null,
  menuPlacementSetting = "auto",
  allowCreate = false,
}) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>  
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label> */}
      <Controller
        control={control}
        name={`${fieldArray}.${index}.${fieldChild}`}
        render={({ field }) =>
          !allowCreate ? ( // @ts-ignore
            <Select
              {...field}
              menuPosition={"fixed"}
              id={uniqueId}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle(fieldArray, index, fieldChild);
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          ) : fieldChild === "tsuat" ? (
            <CreatableSelect
              {...field}
              id={uniqueId}
              menuPosition={"fixed"}
              isValidNewOption={(inputValue, selectValue) => {
                return inputValue !== "" && inputValue < 100;
              }}
              onChange={data => {
                if (data.__isNew__) {
                  data.label =
                    "KHAC:" + String(data.label).padStart(2, "0") + ".00%";
                }
                field.onChange(data);
                onChangeHandle && onChangeHandle(fieldArray, index, fieldChild);
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              onKeyDown={evt => {
                var ASCIICode = evt.which ? evt.which : evt.keyCode;
                if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
                  evt.preventDefault();
              }}
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          ) : (
            <CreatableSelect
              {...field}
              id={uniqueId}
              menuPosition={"fixed"}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle(fieldArray, index, fieldChild);
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              isClearable={true}
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          )
        }
      />
      {/* {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && ( */}
      <UncontrolledTooltip
        // style={{
        //   color: "red",
        //   background: "white",
        //   border: "1px solid red",
        // }}
        placement="right"
        target={uniqueId}
      >
        {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild]
          ? errors[fieldArray][index][fieldChild].message
          : watch(fieldArray)[index][fieldChild]?.label}
      </UncontrolledTooltip>
    </React.Fragment>
  );
};

export const generateDateFieldArray = ({
  labelFrom,
  labelTo,
  isRequire,
  errors,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  disabled,
  control,
  options,
}) => {
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label> */}
      <Controller
        control={control}
        name={`${fieldArray}.${index}.${fieldChild}`}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={disabled ? "" : placeholder}
            options={options}
          />
        )}
      />
      {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && (
          <MessageFormValidate
            error={errors[fieldArray][index][fieldChild].message}
          />
        )}
    </React.Fragment>
  );
};

export const EXTRA_BUTTON = {
  LOAD_TAX: "LOAD_TAX",
  SEARCH_CUSTOMER: "SEARCH_CUSTOMER",
  ADD_ACCOUNT: "ADD_ACCOUNT",
  ADD_PRODUCT: "ADD_PRODUCT",
};

// Reack hook form
export const generateInputField = ({
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldName,
  placeholder,
  register,
  disabled,
  widthLabel,
  control,
  isThousandSeparator = false,
  isTaxCode = false,
  allowNegative = false,
  onChangeHandle,
  extraComponent = {},
  isKHHD = false,
  invoiceSymbolList = [],
  khhdonDefault = "",
  isShowLabel = true,
  styleInput = {},
  decimalScale = 2,
  classForm = "",
  classText = "text-right",
}) => {
  return (
    <React.Fragment>
      <div
        className={`d-flex custom-form mb-2 ${classForm}`}
        style={{ paddingTop: "8px" }}
      >
        {isShowLabel && (
          <div
            style={{
              fontWeight: "500",
              minWidth: widthLabel ? widthLabel : "110px",
              paddingTop: isKHHD && "8px",
            }}
          >
            {label}
            {isRequire && <span className="text-danger"> (*)</span>}:
          </div>
        )}

        <Col className={fieldName === "ttchung_khhdon" ? "d-flex" : ""}>
          {/* {fieldName === "ttchung_khhdon" && (
            <input
              disabled={true}
              type="text"
              autoComplete="off"
              style={{
                borderBottom: "none",
                width: "8px",
                padding: "0px",
                marginLeft: "-17px",
                // marginRight: "1px",
              }}
              className={`form-control `}
              {...register(`${"ttchung_khmshdon"}`)}
            />
          )} */}
          {inputType === "textarea" ? (
            <textarea
              disabled={disabled}
              autoComplete="off"
              type={inputType}
              className={`form-control ${formValidate(
                errors,
                touched,
                fieldName
              )}`}
              placeholder={disabled ? "" : placeholder}
              {...register(`${fieldName}`)}
            />
          ) : isThousandSeparator ? (
            <Controller
              control={control}
              name={`${fieldName}`}
              render={({ field: { onChange, name, value } }) => (
                <NumberFormat
                  autoComplete="off"
                  thousandSeparator={true}
                  decimalScale={decimalScale}
                  style={styleInput}
                  className={`form-control ${classText} ${formValidate(
                    errors,
                    touched,
                    fieldName
                  )}`}
                  allowNegative={allowNegative}
                  disabled={disabled}
                  value={value}
                  onValueChange={v => {
                    onChange(v.value);
                  }}
                />
              )}
            />
          ) : isTaxCode ? (
            <React.Fragment>
              {/* <div className="d-flex align-items-center gap-1"> */}
              {/* <Controller
                control={control}
                name={`${fieldName}`}
                render={({ field: { onChange, name, value } }) => (
                  <NumberFormat
                    format="##########-###"
                    autoComplete="off"
                    style={{ maxWidth: "239px", minWidth: "99px" }}
                    allowEmptyFormatting={false}
                    placeholder={disabled ? "" : placeholder}
                    mask="_"
                    allowNegative={allowNegative}
                    className={`form-control ${formValidate(
                      errors,
                      touched,
                      fieldName
                    )}`}
                    disabled={disabled}
                    value={value}
                    onValueChange={v => {
                      let finalValue = formatTaxCode(v.value);
                      onChange(finalValue);
                      onChangeHandle && onChangeHandle(finalValue, fieldName);
                    }}
                  />
                )}
              /> */}
              <input
                disabled={disabled}
                type="text"
                autoComplete="off"
                style={styleInput}
                className={`form-control ${formValidate(
                  errors,
                  touched,
                  fieldName
                )}`}
                placeholder={disabled ? "" : placeholder}
                {...register(`${fieldName}`)}
              />
              {/* </div> */}
            </React.Fragment>
          ) : isKHHD ? (
            <React.Fragment>
              <Controller
                control={control}
                name={`${fieldName}`}
                render={({ field }) => (
                  <React.Fragment>
                    <Row>
                      <Col className="col-auto pe-0">
                        <span className="input-group-text">
                          {khhdonDefault}
                        </span>
                      </Col>
                      <Col className="ps-0">
                        <Select
                          {...field}
                          isDisabled={disabled}
                          placeholder={placeholder}
                          options={
                            invoiceSymbolList && invoiceSymbolList.length > 0
                              ? invoiceSymbolList.map(item => ({
                                  value: item.id,
                                  label: item.khhdon,
                                }))
                              : []
                          }
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </Row>
                  </React.Fragment>
                )}
              />

              {/* <div className="d-flex align-items-center gap-1">
            <Controller
              control={control}
              name={`${fieldName}`}
              render={({ field: { onChange, name, value } }) => (
                // A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y
                <InputMask
                  mask="******"
                  value={value}
                  disabled={disabled}
                  className={`form-control ${formValidate(
                    errors,
                    touched,
                    fieldName
                  )}`}
                  onKeyDown={e => {
                    const charAllow = [
                      "A",
                      "B",
                      "C",
                      "D",
                      "E",
                      "G",
                      "H",
                      "K",
                      "L",
                      "M",
                      "N",
                      "P",
                      "Q",
                      "R",
                      "S",
                      "T",
                      "U",
                      "V",
                      "X",
                      "Y",
                    ];
                    if (
                      value.replace("_", "").length === 4 &&
                      (e.keyCode === 8 || e.keyCode === 46)
                    ) {
                      e.preventDefault();
                    } else {
                      if (
                        charAllow.indexOf(e.key.toUpperCase()) === -1 &&
                        e.keyCode !== 8
                      ) {
                        e.preventDefault();
                      }
                    }
                  }}
                  onChange={v => {
                    onChange(v.target.value.replace("_", "").toUpperCase());
                  }}
                ></InputMask>
              )}
            />
          </div> */}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {/* <div className="d-flex align-items-center gap-1"> */}
              <input
                disabled={disabled}
                type={inputType}
                autoComplete="off"
                style={styleInput}
                className={`form-control ${formValidate(
                  errors,
                  touched,
                  fieldName
                )}`}
                placeholder={disabled ? "" : placeholder}
                {...register(`${fieldName}`)}
              />
            </React.Fragment>
          )}
          {errors[fieldName] && (
            <MessageFormValidate error={errors[fieldName].message} />
          )}
        </Col>
        {isTaxCode && extraComponent && extraComponent[EXTRA_BUTTON.LOAD_TAX]}
        {fieldName === "nmua_ten" &&
          extraComponent &&
          extraComponent[EXTRA_BUTTON.SEARCH_CUSTOMER]}
        {/* </div> */}
      </div>
    </React.Fragment>
  );
};

export const generateSelectField = ({
  label,
  isRequire,
  errors,
  fieldKey,
  placeholder,
  disabled,
  control,
  options,
  menuPlacementSetting = "auto",
  onChangeHandle,
  isLoading = false,
  allowCreate = false,
  widthLabel,
  extraComponent = {},
  isClearable = false,
}) => {
  return (
    <React.Fragment>
      <div className={`d-flex custom-form mb-2`}>
        <div
          style={{
            fontWeight: "500",
            minWidth: widthLabel ? widthLabel : "110px",
            paddingTop: "8px",
          }}
        >
          {label}
          {isRequire && <span className="text-danger"> (*)</span>}:
        </div>
        <Col>
          <Controller
            control={control}
            name={fieldKey}
            render={({ field }) =>
              !allowCreate ? ( // @ts-ignore
                <Select
                  {...field}
                  isClearable={isClearable}
                  menuPlacement={menuPlacementSetting}
                  isLoading={isLoading}
                  onChange={data => {
                    field.onChange(data);
                    onChangeHandle && onChangeHandle(data, fieldKey);
                  }}
                  isDisabled={disabled}
                  placeholder={disabled ? "" : placeholder}
                  options={options}
                  classNamePrefix="select2-selection"
                />
              ) : (
                <CreatableSelect
                  {...field}
                  onChange={data => {
                    field.onChange(data);
                    onChangeHandle && onChangeHandle(data, fieldKey);
                  }}
                  isOptionSelected={(option, selectValue) =>
                    selectValue.some(i => i === option)
                  }
                  isClearable={true}
                  menuPlacement={menuPlacementSetting}
                  isDisabled={disabled}
                  placeholder={disabled ? "" : placeholder}
                  options={options}
                  classNamePrefix="select2-selection"
                />
              )
            }
          />

          {errors[fieldKey] && (
            <MessageFormValidate error={errors[fieldKey].message} />
          )}
        </Col>
        {fieldKey === "nmua_stknhang" &&
          extraComponent &&
          extraComponent[EXTRA_BUTTON.ADD_ACCOUNT]}
      </div>
    </React.Fragment>
  );
};

export const generateDateField = ({
  labelFrom = "",
  labelTo = "",
  isRequire,
  errors,
  field,
  placeholder,
  disabled,
  control,
  options,
  styleInput = {},
  widthLabel = null,
  pluginDate = null,
  classForm = "",
}) => {
  return (
    <React.Fragment>
      <div
        className={`d-flex custom-form mb-2 ${classForm}`}
        style={{ paddingTop: "8px" }}
      >
        <div
          style={{
            fontWeight: "500",
            minWidth: widthLabel ? widthLabel : "110px",
          }}
        >
          {labelFrom}
          {labelFrom &&
            isRequire &&
            field !== ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP.field && (
              <span className="text-danger"> (*)</span>
            )}
          {labelTo && `- ${labelTo}`}
          {labelTo && isRequire && <span className="text-danger"> (*)</span>}:
        </div>
        <Col style={styleInput}>
          <Controller
            control={control}
            name={field}
            render={({ field }) =>
              pluginDate === "monthOnly" ? ( // @ts-ignore
                <Flatpickr
                  // {...field}
                  disabled={disabled}
                  className="form-control d-block Flatpickr__Input"
                  placeholder={disabled ? "" : placeholder}
                  options={{
                    ...options,
                    mode: "range",
                    plugins: [
                      monthSelectPlugin({
                        shorthand: true, // defaults to false
                        dateFormat: "m/Y - m/Y", // defaults to "F Y"
                        altFormat: "Tm/ Y", // defaults to "F Y"
                      }),
                    ],
                  }}
                />
              ) : (
                <Flatpickr
                  {...field}
                  disabled={disabled}
                  className="form-control d-block Flatpickr__Input"
                  placeholder={disabled ? "" : placeholder}
                  options={options}
                />
              )
            }
          />
          {errors[field] && (
            <MessageFormValidate error={errors[field].message} />
          )}
        </Col>
      </div>
    </React.Fragment>
  );
};

export const generateCheckboxField = ({
  labelFrom,
  labelTo,
  isRequire,
  errors,
  field,
  placeholder,
  disabled,
  control,
  options,
}) => {
  return (
    <React.Fragment>
      <Label htmlFor={field}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={field}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={disabled ? "" : placeholder}
            options={options}
          />
        )}
      />
      {errors[field] && <MessageFormValidate error={errors[field].message} />}
    </React.Fragment>
  );
};

// Reack hook form object
export const generateInputFieldObject = ({
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldObject,
  field,
  placeholder,
  register,
  disabled,
}) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidateObject(
            errors,
            touched,
            fieldObject,
            field
          )}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldObject}.${field}`)}
        />
      ) : (
        <input
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidateObject(
            errors,
            touched,
            fieldObject,
            field
          )}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldObject}.${field}`)}
        />
      )}
      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

export const generateSelectFieldObject = ({
  label,
  isRequire,
  errors,
  fieldObject,
  field,
  placeholder,
  disabled,
  control,
  options,
  menuPlacementSetting = "auto",
}) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={`${fieldObject}.${field}`}
        render={({ field }) => (
          <Select
            {...field}
            menuPlacement={menuPlacementSetting}
            isDisabled={disabled}
            placeholder={disabled ? "" : placeholder}
            options={options}
            classNamePrefix="select2-selection"
          />
        )}
      />

      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

export const generateDateFieldObject = ({
  labelFrom,
  labelTo,
  isRequire,
  errors,
  fieldObject,
  field,
  placeholder,
  disabled,
  control,
  options,
}) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={`${fieldObject}.${field}`}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={disabled ? "" : placeholder}
            options={options}
          />
        )}
      />
      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

//Check show/hide with page view
const checkShowWithPageView = (item, pageView) => {
  if (item.isShowWithPageView && item.isShowWithPageView.length > 0) {
    if (item.isShowWithPageView.findIndex(i => i === pageView) === -1) {
      return false;
    }
    return true;
  } else {
    return true;
  }
};

export const loopGenerateField = ({
  item,
  label,
  placeholder,
  errors,
  touchedFields,
  register,
  control,
  OPTION_GROUP,
  optionDateLocale,
  customFormClass = "",
  onChangeHandle = null,
  pageView = null,
  extraComponent = null,
  disableForm = false,
  invoiceSymbolList = [],
  khhdonDefault = "",
  mode = "",
  minDate = null,
  watch = null,
  setValue = null,
}) => {
  if (item.field === FIELD_EXTRA.FIELD_EMPTY.field) {
    return <Col></Col>;
  }
  let isNotAdjustChangeInfoFlag = true;

  const conditionVisible = item.conditionVisible;
  if (conditionVisible) {
    for (const k in conditionVisible) {
      let finalWatchValue = watch(k)?.value ? watch(k)?.value : watch(k);
      if (!conditionVisible[k].find(i => i === finalWatchValue)) {
        item.isHide = true;
      }
    }
  }
  if (item.isHide) {
    return "";
  }
  let xs = item.xs;
  switch (item.type) {
    case "toggleField":
      return (
        <Col key={item.field} xs={xs} style={{ ...item.styleCol }}>
          {generateToggleField({
            label: label,
            isRequire: item.required,
            field: item.field,
            listData: item.listData,
            setValue: setValue,
            watch,
            isDisable: disableForm,
            widthLabel: item.widthLabel,
            errors,
          })}
        </Col>
      );
    case "radioField":
      return (
        <Col key={item.field} xs={xs} style={{ ...item.styleCol }}>
          {generateRadioField({
            label: label,
            isRequire: item.required,
            field: item.field,
            listData: item.listData,
            setValue: setValue,
            watch,
            register,
            isDisable: disableForm,
            isHide: false,
            style: {
              marginTop: "-7px",
              marginBottom: "10px",
            },
            widthLabel: item.widthLabel,
            errors,
          })}
        </Col>
      );
    case "text":
    case "number":
    // Ô email dùng chung khuôn text, chỉ khác ở chỗ schema kiểm tra định dạng
    case "email":
      return (
        <Col key={item.field} xs={xs} style={{ ...item.styleCol }}>
          {/* <FormGroup
            className={`mb-2 ${customFormClass}`}
            style={{ width: item.width }}
          > */}
          {generateInputField({
            label: label,
            isRequire: item.required,
            inputType: item.type,
            errors: errors,
            touched: touchedFields,
            fieldName: item.field,
            placeholder: placeholder,
            register: register,
            disabled:
              item.disabled || (disableForm && isNotAdjustChangeInfoFlag),
            widthLabel: item.widthLabel,
            control: control,
            isThousandSeparator: item.isThousandSeparator,
            isTaxCode: item.isTaxCode,
            allowNegative: item.allowNegative,
            onChangeHandle: onChangeHandle,
            extraComponent: extraComponent,
            isKHHD: item.isKHHD,
            invoiceSymbolList: invoiceSymbolList,
            khhdonDefault: khhdonDefault,
            isShowLabel: item.isShowLabel,
            styleInput: item.styleInput,
            decimalScale: item.decimalScale || 0,
            classForm: item.classForm,
            classText: item.classText,
          })}
          {/* </FormGroup> */}
        </Col>
      );
    case "select":
      return (
        <Col key={item.field} xs={xs} style={{ ...item.styleCol }}>
          <FormGroup className="mb-2">
            {generateSelectField({
              label: label,
              isRequire: item.required,
              errors: errors,
              fieldKey: item.field,
              placeholder: placeholder,
              disabled:
                item.disabled || (disableForm && isNotAdjustChangeInfoFlag),
              control: control,
              options: OPTION_GROUP[item.field],
              menuPlacementSetting: "top",
              onChangeHandle: onChangeHandle,
              isLoading: false,
              allowCreate: item.allowCreate,
              widthLabel: item.widthLabel,
              extraComponent: extraComponent,
              isClearable: item.isClearable,
            })}
          </FormGroup>
        </Col>
      );
    case "date":
      let optionDate = optionDateLocale;
      if (item.field === "ttchung_nlap" && !disableForm) {
        const currentDate = new Date();
        const defaultMaxDate = moment(currentDate.getTime()).format(
          "DD-MM-YYYY"
        );
        // const defaultMinDate = moment(
        //   new Date(currentDate.getFullYear(), 0, 1)
        // ).format("DD-MM-YYYY");
        optionDate = {
          ...optionDate,
          minDate: minDate,
          maxDate: defaultMaxDate,
        };
      }
      optionDate = {
        ...optionDate,
        ...item.optionDate,
      };
      // Không chọn được ngày tương lai
      if (item.notFeatureDate) {
        const currentDate = new Date();
        const defaultMaxDate = moment(currentDate.getTime()).format(
          "DD-MM-YYYY"
        );
        optionDate = {
          ...optionDate,
          maxDate: defaultMaxDate,
        };
      }
      return (
        <Col key={item.field} xs={xs} style={{ ...item.styleCol }}>
          <FormGroup className="mb-2">
            {generateDateField({
              labelFrom: label,
              isRequire: item.required,
              errors: errors,
              field: item.field,
              placeholder: " DD/MM/YYYY",
              disabled:
                item.disabled || (disableForm && isNotAdjustChangeInfoFlag),
              control: control,
              options: optionDate,
              styleInput: item.styleInput,
              classForm: item.classForm,
              widthLabel: item.widthLabel,
              pluginDate: item.pluginDate,
            })}
          </FormGroup>
        </Col>
      );
    default:
      break;
  }
};

//
//type :raw ,tct-response ,signed
export const getResourceIdXML = (resource_list, type, mltdiep = null) => {
  //   console.log(
  //     "🚀 ~ file: form_helper.js ~ line 883 ~ getResourceIdXML ~ resource_list",
  //     resource_list
  //   );
  let resource = null;
  if (type === "tct-response") {
    // If k có mltdiep thì lấy id cuối
    if (mltdiep === null) {
      resource = resource_list
        .sort((a, b) => b.id - a.id)
        .find(item => item.type === type);
    } else {
      resource = resource_list.find(
        item => item.type === type && item.mltdiep === mltdiep
      );
    }
    if (!resource) {
      resource = resource_list
        .sort((a, b) => b.id - a.id)
        .find(item => item.type === "signed");
    }
  } else {
    resource = resource_list
      .sort((a, b) => b.id - a.id)
      .find(item => item.type === type);
  }
  //   console.log(
  //     "🚀 ~ file: form_helper.js ~ line 883 ~ getResourceIdXML ~ resource_list",
  //     resource
  //   );
  return resource ? resource.id : null;
};
